import React, { useEffect, useState } from "react";
import { CustomGetAPI } from "../Utils/APIConnector";
import Loader from "../Utils/Loader";
import { formatDateTime } from "../Utils/common";
import { useNavigate } from "react-router-dom";

export default function NotificationLogs({
  isLoading,
  notificationData,
  setShow,
}) {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      {isLoading ? (
        <div>
          <Loader />
        </div>
      ) : (
        <>
          {notificationData?.length > 0 ? (
            <div className="row">
              {notificationData?.map((notification, idx) => (
                <div
                  className="col-12 notifyDiv cursor-pointer"
                  onClick={() => {
                    setShow(false);
                    navigate(notification?.relatedUrl);
                  }}
                >
                  <b className="d-flex justify-content-between">
                    {notification?.title}{" "}
                    {!notification?.isRead && (
                      <img src="/images/redDot.svg" alt="" />
                    )}
                  </b>
                  <p className="m-0">{notification?.message}</p>
                  <span>
                    {" "}
                    {formatDateTime(
                      notification?.createdAt,
                      "DD/MM/YY hh:mm A"
                    )}
                  </span>
                  {idx != notificationData?.length - 1 && <hr />}
                </div>
              ))}
            </div>
          ) : (
            <div className="row">
              <div className="col-12 text-center">No Recent Notification's</div>
            </div>
          )}
        </>
      )}
    </React.Fragment>
  );
}
